<template>
    <div>
        <hr />
        <pc-label
            v-bind:label="label"
            v-bind:show-help="showHelp"
            v-bind:help-link="showHelpLinkOnly"
            v-on:help-clicked="emitHelpClicked" />
        <div>
            <slot name="help" />
        </div>
        <template v-if="formula">
            <div class="d-flex justify-content-between">
                <div v-bind:class="{ 'text-danger fst-italic': inError }">
                    {{ summary }}
                </div>
                <pc-button
                    v-if="showFormulaDetails"
                    class="text-nowrap"
                    link
                    v-on:click="toggleDetails">
                    {{ showHideDetailsText }}
                </pc-button>
            </div>
            <transition
                v-bind:class:css="false"
                v-on:enter="enter"
                v-on:leave="leave">
                <div v-if="showDetails">
                    <formula
                        ref="formula"
                        v-bind:formula="formula"
                        v-bind:show-separators="showSeparators"
                        simple />
                </div>
            </transition>
        </template>
        <div
            v-else
            class="text-danger fst-italic">
            {{ configurationErrorMessage }}
        </div>
        <hr class="mb-0" />
    </div>
</template>

<script>
    import base from "./_elementBase";
    import { PROJECT_TYPES } from "SharedStores/Project/projectStore";
    import { PROGRAM_TYPES, PROGRAM_NAMESPACE } from "SharedStores/Program/programStore";
    import { isModuleRegistered } from "SharedStores/util";
    import formula from "Formula/Components/formula.vue";
    import { RESULT_STATUS } from "Formula/evaluators/result";
    import { SLIDE_DOWN_UP } from "Util/animations";
    import { THOUSAND_SEPARATOR_FORMATTER } from "Util/dataFormatters";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/calculatedField.i18n";
    import { DATA_FIELD_TYPE } from "Types/dataFieldTypes";

    export default {
        components: { formula },
        extends: base,
        data() {
            return { showDetails: false };
        },
        computed: {
            showFormulaDetails() {
                return this.getBooleanPropertyValue("showformuladetails");
            },
            formula() {
                if (this.isProjectModuleRegistered()) {
                    const formulaId = this.element.Properties.formulaid;
                    return this.$store.getters[PROJECT_TYPES.getters.evaluatedFieldFromId](formulaId);
                } else if (isModuleRegistered(PROGRAM_NAMESPACE, this.$store.state)) {
                    const formulaId = this.element.Properties.formulaid;
                    return this.$store.getters[PROGRAM_TYPES.getters.calculatedFieldFromId](formulaId);
                }
                return null;
            },
            summary() {
                if (this.inError) {
                    return this.errorPrefix + this.formula.result.Message;
                }
                const value = this.formula.result ? this.formula.result.Value : this.defaultResultValueText;
                return this.formatSummary(value);
            },
            inError() {
                return this.formula.result && this.formula.result.Status === RESULT_STATUS.Error;
            },
            showHideDetailsText() {
                if (this.showDetails) {
                    return this.hideDetailsMessage;
                }
                return this.showDetailsMessage;
            },
            dataField() {
                if (this.formula.PublicDataFieldDefinitionId) {
                    return this.$store.getters[PROGRAM_TYPES.getters.dataFieldDefinitionFromId](
                        this.formula.PublicDataFieldDefinitionId
                    );
                }
                return null;
            },
            showSeparators() {
                return this.dataField && this.dataField.ShowSeparators;
            },
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        },
        methods: {
            toggleDetails() {
                this.showDetails = !this.showDetails;
            },
            async enter(el, done) {
                await this.$refs.formula.wrap();
                SLIDE_DOWN_UP.enter(el, done);
            },

            leave: SLIDE_DOWN_UP.leave,
            formatSummary(value) {
                if (this.formula.ResultType === DATA_FIELD_TYPE.Decimal && typeof value == "number") {
                    let precision = this.getNumericPropertyValue("precision");
                    precision = precision === null ? 2 : precision;
                    value = value.toFixed(precision);
                    if (this.showSeparators) {
                        value = THOUSAND_SEPARATOR_FORMATTER.format(value);
                    }
                }

                const units = this.element.Properties.units;
                if (this.element.Properties.units) {
                    const prefix = this.getBooleanPropertyValue("prefix");
                    value = prefix ? `${units} ${value}` : `${value} ${units}`;
                }

                return value;
            }
        }
    };
</script>
